import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { CancelButton, SaveButton } from "../../common/Button";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { Context } from "../../../utils/context";
library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData ,IMG_URL} = useContext(Context);

  const id = props.show;
  const [role, setRole] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [data, setData] = useState();
  const [formData, setFormData] = useState({
    id: "",
    first_name: "",
    last_name: "",
    role_id: "",
    contact_no: "",
    email: "",
    image: null,
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleKeyPressContact = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    if (!/^\d$/.test(keyValue)) {
      event.preventDefault();
    }
  };

  const handleChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    } else if (e && e.value) {
      setFormData({ ...formData, role_id: e });
    }
  };
  const [preview, setPreview] = useState(null);
  const onFileSelect = (e) => {
    const file = e.target.files[0];

    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));

      // ✅ show selected image preview
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = await Validation.FormValidation({
      classname: ".employeedetailclass",
    });

    const validationErrorsSelect = Validation.SelectValidation({
      classname: ".employeedetailclass",
    });
    if (validationErrors && validationErrorsSelect) {
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("role_id", formData.role_id?.value);
        formDataToSend.append("first_name", formData.first_name);
        formDataToSend.append("last_name", formData.last_name);
        formDataToSend.append("contact_no", formData.contact_no);
        formDataToSend.append("email", formData.email);
        formDataToSend.append("password", formData.password);
        formDataToSend.append("cpassword", formData.cpassword);
        if (formData.image) {
          formDataToSend.append("image", formData.image);
        }

        const response = await postData(
          `/employee/employee-details/${id}`,
          formDataToSend,
        );
        if (response.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/employee/employee-details/${id}`);
    setData(response);
    setFormData(response?.data);
    if (response?.data?.image) {
      setPreview(IMG_URL+response.data.image); // backend image URL
    }
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const GetAllRole = async () => {
    const response = await getData("/allroles");
    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "role_id",
          label: data.name,
        });
      });
    }
    setRole(option);
  };

  useEffect(() => {
    GetAllRole();
  }, []);

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Edit Employee</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit Employee</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      {/* <Row className="">
                        <Col xxl={12} xl={12} md={10}> */}
                      <Form
                        onSubmit={handleSubmit}
                        role="form"
                        className="employeedetailclass"
                      >
                        <Row>
                          {/* <Col
                                  lg={8}
                                  md={10}
                                  className=" mx-auto Add-content"
                                >
                                  <Row> */}

                          <Col md={6}>
                            <div className="main-form-section mt-5">
                              <Row className="row justify-content-center mb-2">
                                <Form.Label column sm={3}>
                                  Employee Role
                                </Form.Label>
                                <Col sm={6}>
                                  <Select
                                    name="role_id"
                                    className="input-mandatory"
                                    value={formData?.role_id}
                                    options={role}
                                    onChange={handleChange}
                                  />
                                  <span className="error-message"></span>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="main-form-section mt-5">
                              <Row className="justify-content-center">
                                <Form.Label column sm={3}>
                                  Employee Name
                                </Form.Label>
                                <Col sm={6}>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        name="first_name"
                                        value={formData?.first_name}
                                        onChange={handleChange}
                                        placeholder="Employee Name"
                                        id="inputEmail3"
                                        className="input-mandatory"
                                      />
                                    </InputGroup>
                                    <span className="error-message"></span>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="main-form-section mt-5">
                              <Row className="justify-content-center">
                                <Form.Label column sm={3}>
                                  Employee Last Name
                                </Form.Label>
                                <Col sm={6}>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        name="last_name"
                                        value={formData?.last_name}
                                        onChange={handleChange}
                                        placeholder="Employee Name"
                                        id="inputEmail3"
                                        className="input-mandatory"
                                      />
                                    </InputGroup>
                                    <span className="error-message"></span>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="main-form-section mt-5">
                              <Row className="justify-content-center">
                                <Form.Label column sm={3}>
                                  Employee Mobile
                                </Form.Label>
                                <Col sm={6}>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="tel"
                                        name="contact_no"
                                        value={formData?.contact_no}
                                        onChange={handleChange}
                                        placeholder="Employee Mobile"
                                        onKeyPress={handleKeyPressContact}
                                        id="inputEmail3"
                                        maxLength={10}
                                        className="input-mandatory"
                                      />
                                    </InputGroup>
                                    <span className="error-message"></span>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="main-form-section mt-5">
                              <Row className="justify-content-center">
                                <Form.Label column sm={3}>
                                  Employee Email
                                </Form.Label>
                                <Col sm={6}>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData?.email}
                                        onChange={handleChange}
                                        placeholder="Employee Email"
                                        id="inputEmail3"
                                        className="input-mandatory"
                                      />
                                    </InputGroup>
                                    <span className="error-message"></span>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="main-form-section mt-5">
                              <Row className="justify-content-center">
                                <Form.Label column sm={3}>
                                  Employee Image
                                </Form.Label>
                                <Col sm={6}>
                                  <Form.Group>
                                    <Form.Control
                                      type="file"
                                      name="image"
                                      accept="image/*"
                                      onChange={onFileSelect}
                                      // className="input-mandatory"
                                    />
                                    <span className="error-message"></span>
                                    {preview && (
                                      <div className="mt-3">
                                        <img
                                          src={preview}
                                          alt="Employee"
                                          style={{
                                            width: "120px",
                                            height: "120px",
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                            border: "1px solid #ddd",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="main-form-section mt-5">
                              <Row className="justify-content-center">
                                <Form.Label column sm={3}>
                                  Employee Password
                                </Form.Label>
                                <Col sm={6}>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        name="password"
                                        value={formData?.password}
                                        onChange={handleChange}
                                        placeholder="Employee Password"
                                        id="inputEmail3"
                                        // className="input-mandatory"
                                      />
                                    </InputGroup>
                                    <span className="error-message"></span>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="main-form-section mt-5">
                              <Row className="justify-content-center">
                                <Form.Label column sm={3}>
                                  Confirm Password
                                </Form.Label>
                                <Col sm={6}>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        name="cpassword"
                                        value={formData?.cpassword}
                                        onChange={handleChange}
                                        placeholder="Re-enter password"
                                        id="inputEmail3"
                                        // className="input-mandatory"
                                      />
                                    </InputGroup>
                                    <span className="error-message"></span>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                          {/* </Row> */}

                          <Row className="mt-5 pb-3">
                            <div className="d-flex justify-content-center">
                              <Link>
                                <CancelButton
                                  name={"cancel"}
                                  handleClose={props.handleClose}
                                />
                              </Link>
                              <SaveButton
                                name={"save"}
                                handleSubmit={handleSubmit}
                              />
                            </div>
                          </Row>
                          {/* </Col> */}
                        </Row>
                      </Form>
                      {/* </Col>
                      </Row> */}
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
